// extracted by mini-css-extract-plugin
module.exports = {"centered":"crypto_centered__P7SGx","cryptoAddresses":"crypto_cryptoAddresses__hQj4y","coinList":"crypto_coinList__fMQPI"};